import './dayjsSetup';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { BreakpointProvider } from '@/contexts/BreakpointContext';
import { TableScrollBudgetProvider } from '@/contexts/TableScrollBudgetContext';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <ThemeProvider>
            <BreakpointProvider>
                <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                    <TableScrollBudgetProvider>
                        <App />
                    </TableScrollBudgetProvider>
                </BrowserRouter>
            </BreakpointProvider>
        </ThemeProvider>
    </Provider>,
);
